// Device-local 'YYYY-MM-DD' for streak math. The server treats this as
// authoritative (see api.ts/localDateSchema) — every answer submit and every
// streak read should funnel through here so the format stays consistent.

export function getDeviceLocalDate(now: Date = new Date()): string {
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}
